import { Injectable, ElementRef, EventEmitter } from '@angular/core';


@Injectable()
export class DraggableService {

  boundary: ElementRef;
  showPopup: any;
  showDragEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;
  }


}
